<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/ARHUD/ARHUD.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">AR-HUD</div>
                <div class="detail-banner-desc">
                  The AR-HUD based on LCOS PGU defines the presentation of driving information with its core advantages of ultra-high-definition display (resolution of 1920×1080, supporting 2K/4K evolution), large field of view (FOV 13°×4°), compact size (11L), and high brightness (13000nit);<br />
                  With its high resolution and wide field of view design, the LCOS AR-HUD can perfectly integrate real road conditions with virtual information, displaying navigation guidance, intelligent driving assistance prompts, and key driving data in real time, greatly enhancing driving safety. In addition, the system also supports the display of audio and video entertainment information, balancing practicality and fun;<br />
                  Compared to traditional HUDs, LCOS AR-HUDs offer comprehensive upgrades in terms of clarity, brightness, and human-machine interaction experience, eliminating the need for drivers to frequently lower their heads to check the dashboard, reducing distraction, and creating a safer and more intelligent future cockpit experience.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>

                    <div class="detail-desc">
                        <div>
                            Brightness: 13000nit.
                        </div>
                        <div>
                            Volume: 11L.
                        </div>
                        <div>
                            PGU: LCOS(HUA WEI H300).
                        </div>
                        <div>
                            Augmented reality: Virtual-real fusion, Dynamic navigation, Improve driving safety.
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Product Introduction
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/ARHUD/ARHUD-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">13° x 4°</div>
                                    <div class="k">FOV</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">VID 10m</div>
                                    <div class="k">VID</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1920*1080</div>
                                    <div class="k">Resolution</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: 'AR-HUD - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/ARHUD.html'

};

import { createApp } from 'vue';
import App from './ARHUD.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./ARHUD.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
